import React from "react";

function Footer() {
  return (
    <div className="footer-bg">
      <div className="wrapper">
        <p className="footer">
          ©2025 Accel1 Inc. All Rights Reserved. <b>|</b>
          <span>Concept & Design by eparivartan</span>
        </p>
      </div>
    </div>
  );
}

export default Footer;
